export default "__VITE_ASSET__62adf8af__"